export const UpholsteryType = {
  None: 0,
  Leather: 1,
  Cloth: 2,
  Vinyl: 3,
}

export const NormalizedUpholsteryTypes = {
  [UpholsteryType.None]: 'None',
  [UpholsteryType.Leather]: 'Leather',
  [UpholsteryType.Cloth]: 'Cloth',
  [UpholsteryType.Vinyl]: 'Vinyl',
}
